var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.flag)?_c('div',{staticClass:"currency",class:_vm.imgclass},[_c('a-icon',{attrs:{"type":"loading"}})],1):_c('img',{style:(_vm.imgstyle),attrs:{"src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }